import React, { memo, useEffect, useRef, useState } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/customAvatarStyle';
import { makeStyles } from '@material-ui/core';
import { AccountsService } from 'services/accounts/accounts';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICustomAvatarProps {
	image?: string;
	accountId?: string | null;
	alt?: string;
	customClasses?: string;
	placeholderIcon: React.ReactElement;
	styles?: any;
}

const CustomAvatar = ({ image, placeholderIcon, alt, styles, accountId, customClasses }: ICustomAvatarProps) => {
	const classes = useStyles();
	const isMounted = useRef(true);
	const [icon, setIcon] = useState<any>();

	const getIcon = (accountId: string) => {
		return AccountsService.getCorpAccountPhoto(accountId).subscribe(
			(value) => {
				if (isMounted.current) {
					setIcon(value.response);
				}
			},
			() => {}
		);
	};

	useEffect(() => {
		if (accountId) {
			getIcon(accountId);
		} else {
			setIcon(null);
		}
	}, [accountId]);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	return (
		<>
			{image || icon ? (
				<img
					src={icon ? icon : image}
					alt={alt || ''}
					className={classes.image + ' ' + customClasses}
					style={styles}
				/>
			) : (
				placeholderIcon
			)}
		</>
	);
};

export default memo(CustomAvatar);
